import { FindingType } from '@/api/domains/analyses/types';
import { FindingTypeConfig } from '../types';

export const getFindingTypeConfig = (type: FindingType): FindingTypeConfig => {
  const configs: Record<FindingType, FindingTypeConfig> = {
    GAP: { icon: 'pi-exclamation-triangle', label: 'Gap', color: '#ff9800' },
    SUPPLEMENT: {
      icon: 'pi-plus-circle',
      label: 'Supplement',
      color: '#4caf50'
    },
    CONFLICT: { icon: 'pi-times-circle', label: 'Conflict', color: '#f44336' },
    ALIGNMENT: {
      icon: 'pi-check-circle',
      label: 'Alignment',
      color: '#2196f3'
    },
    CONTRADICTION: {
      icon: 'pi-bolt',
      label: 'Contradiction',
      color: '#9c27b0'
    }
  };
  return configs[type] || { icon: 'pi-circle', label: type, color: '#616161' };
};
